/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M6.2896 6.6467C6.823 3.7193 9.3876 1.5 12.4688 1.5c1.5498 0 3.1419.5764 4.3377 1.5434 1.1917.9636 1.9435 2.272 1.9435 3.7378 0 .1978-.0091.393-.0269.5855l-.0577.6248.6048.1671a4.3923 4.3923 0 0 1 1.6639.879.75.75 0 0 0 .9676-1.1463 5.903 5.903 0 0 0-1.6527-.9855c.0007-.0414.001-.083.001-.1246 0-2.0151-1.0389-3.7225-2.5003-4.9042C16.2924.6987 14.3689 0 12.4688 0 8.8194 0 5.758 2.5116 4.9165 5.9003 2.0753 6.7328 0 9.3576 0 12.4688c0 3.7796 3.064 6.8437 6.8438 6.8437a.75.75 0 0 0 0-1.5C3.8925 17.8125 1.5 15.42 1.5 12.4688c0-2.5616 1.8032-4.7038 4.21-5.2234l.4897-.1058.0899-.4929Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.8846 11.0322c1.2821-.4931 3.0025-.7822 4.8654-.7822 1.8629 0 3.5833.2891 4.8654.7822.6386.2456 1.2068.5564 1.6284.9398.4218.3836.7562.8988.7562 1.528v7.2559c-.0021.6265-.3357 1.1397-.7562 1.5221-.4216.3834-.9898.6942-1.6284.9398-1.2821.4931-3.0025.7822-4.8654.7822-1.8629 0-3.5833-.2891-4.8654-.7822-.6386-.2456-1.2068-.5564-1.6284-.9398-.4205-.3824-.7541-.8956-.7562-1.5221V13.5c0-.6292.3344-1.1444.7562-1.528.4216-.3834.9898-.6942 1.6284-.9398ZM11 15.5558V17.25c0 .0612.0293.2036.2654.4182.2362.2149.6199.4427 1.1576.6496 1.0705.4117 2.6001.6822 4.327.6822s3.2565-.2705 4.327-.6822c.5377-.2069.9214-.4347 1.1576-.6496.2361-.2146.2654-.357.2654-.4182v-1.6942c-.2716.1538-.5695.2908-.8846.412-1.2821.4931-3.0025.7822-4.8654.7822-1.8629 0-3.5833-.2891-4.8654-.7822-.3151-.1212-.613-.2582-.8846-.412Zm0 5.1942v-1.4442c.2716.1538.5695.2908.8846.412 1.2821.4931 3.0025.7822 4.8654.7822 1.8629 0 3.5833-.2891 4.8654-.7822.3151-.1212.613-.2582.8846-.412V20.75c0 .0612-.0293.2036-.2654.4182-.2362.2149-.6199.4427-1.1576.6496-1.0705.4117-2.6001.6822-4.327.6822s-3.2565-.2705-4.327-.6822c-.5377-.2069-.9214-.4347-1.1576-.6496-.2361-.2146-.2654-.357-.2654-.4182Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuDatabaseFilled'
);
